export let environment = {
  production: false,
  // masterUrl: 'https://bga68oamu6.execute-api.us-east-1.amazonaws.com/test/',
  masterUrl: 'https://v1.hubtricity.com/api/',
  versionUrl: 'http://ngauge-testing.s3-website.us-east-2.amazonaws.com/version.json',
  mapApiKey: 'AIzaSyCilxATLezZx0v2hMl6dNbyO4LQp0waTRs',
  reCaptchaSiteKey: '6LcaVNAZAAAAAJuR1jXNOhA7xItt8IQAN7UgAGv2'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts